import React from 'react';
import { Comment } from 'api/document/types/document';
import { FormWithPrivacyHandler } from 'components/molecules/custom-form';

interface Props {
  initialHtml: string;
  placeholder: string;
  projectId: number;
  comment: Comment;
  onEditFormClose: () => void;
  onEdit: (value: string) => void;
  onPrivateClick?: () => void;
}

export const EditComment: React.FC<Props> = ({
  initialHtml,
  placeholder,
  projectId,
  comment,
  onEditFormClose,
  onEdit,
  onPrivateClick = () => {},
}) => {
  const handleEdit = (content) => {
    if (content.length > 1) {
      onEdit(content);
      onEditFormClose();
    }
  };

  return (
    <FormWithPrivacyHandler
      initialFormVisibility
      submitFormLabel="save"
      onSubmit={handleEdit}
      isPrivate={comment.private}
      onClose={onEditFormClose}
      initialData={initialHtml}
      placeholder={placeholder}
      hidePrivateToggler
      projectId={projectId}
      onPrivateBtnClick={onPrivateClick}
    />
  );
};
